import { render } from "./SchemeEditor.vue?vue&type=template&id=adc572f4&scoped=true&ts=true"
import script from "./SchemeEditor.vue?vue&type=script&lang=ts"
export * from "./SchemeEditor.vue?vue&type=script&lang=ts"

import "./SchemeEditor.vue?vue&type=style&index=0&id=adc572f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc572f4"]])

export default __exports__